<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
  <div class="d-flex flex-row justify-content-between pb-2">
    <div class="d-flex flex-row">
      <input (change)="onFileSelected($event)" class="open-file" style="display: none;" type="file" id="openFile"
             #openFile name="openFile" accept="image/png, image/jpg, image/jpeg"/>
      <img class="edit_employee_profile_picture"
           (click)="openAddImage()"
           [src]="determineImageForEmployee(employeeModel.pictureUrl)"
           alt="profile-picture">
      <div class="picture-edit align-self-center">
        <p class=" hide_mobile primary_medium_text_16 m-0">
          {{ 'EMPLOYEES.UPLOAD_IMAGE_MESSAGE' | translate }}
          <label *ngIf="pictureIsWrongFormat">
            <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
               pTooltip="{{'EMPLOYEES.WRONG_FORMAT' | translate}}" tooltipPosition="top"></i>
          </label>
        </p>
        <p class="show_mobile primary_medium_text_16 m-0">
          {{ 'EMPLOYEES.CHANGE_IMAGE_MESSAGE' | translate }}
          <label *ngIf="pictureIsWrongFormat">
            <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
               pTooltip="{{'EMPLOYEES.WRONG_FORMAT' | translate}}" tooltipPosition="top"></i>
          </label>
        </p>
      </div>
    </div>
  </div>

  <div class="display_block_mbl d-flex flex-row justify-content-between pb-2">
    <div class="w_100_mbl w-50">
      <label class="lbl_pos_field">{{'EMPLOYEES.NAME' | translate}}
        <i *ngIf="errorModel!=null && errorModel['FirstName']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['FirstName']|translate}}" tooltipPosition="top"></i>
      </label>
      <input type="text" class="primary_input_field" [(ngModel)]="employeeModel.firstName">
    </div>
    <div class="w_100_mbl w-50">
      <label class="lbl_pos_field">{{'EMPLOYEES.SURNAME' | translate}}
        <i *ngIf="errorModel!=null && errorModel['LastName']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['LastName']|translate}}" tooltipPosition="top"></i>
      </label>
      <input type="text" class="primary_input_field" [(ngModel)]="employeeModel.lastName">
    </div>
  </div>
  <div class="display_block_mbl d-flex flex-row justify-content-between pb-2">
    <div class="w_100_mbl w-50">
      <label class="lbl_pos_field">{{'EMPLOYEES.EMAIL' | translate}}
        <i *ngIf="(errorModel!=null && errorModel['Email']!=null) && !email.errors?.pattern"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['Email']|translate}}" tooltipPosition="top"></i>
        <i *ngIf="email.errors?.pattern"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{'INFO.INVALID_EMAIL'|translate}}" tooltipPosition="top"></i>
      </label>
      <input type="email" #email=ngModel class="primary_input_field" [(ngModel)]="employeeModel.email"
             pattern="^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$" [disabled]="enableEdit">
    </div>
    <div class="w_100_mbl w-50">
      <label class="lbl_pos_field">{{'EMPLOYEES.PHONE' | translate}}
        <i *ngIf="errorModel!=null && errorModel['Phone']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['Phone']|translate}}" tooltipPosition="top"></i>
      </label>
      <input type="number" class="primary_input_field custom_number_input" [(ngModel)]="employeeModel.phone">
    </div>
  </div>
  <div class="display_block_mbl d-flex flex-row justify-content-between pb-2">
    <div class="w_100_mbl w-50">
      <label class="lbl_pos_field">{{'EMPLOYEES.ADDRESS' | translate}}
        <i *ngIf="errorModel!=null && errorModel['Address']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['Address']|translate}}" tooltipPosition="top"></i>
      </label>
      <input type="text" class="primary_input_field" [(ngModel)]="employeeModel.address">
    </div>
    <div class="w_100_mbl w-50">
      <label class="lbl_pos_field">{{'EMPLOYEES.ROLE' | translate}}
        <i *ngIf="errorModel!=null && errorModel['Role']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['Role']|translate}}" tooltipPosition="top"></i>
      </label>
      <p-dropdown appendTo="body" class="pos_dropdown" [options]="rolesDropdownHelperModels" [(ngModel)]="employeeModel.venueEmployeeTypeId" optionLabel="name"
                  optionValue="id" placeholder="{{'EMPLOYEES.SELECT_ROLE' | translate}}"></p-dropdown>
    </div>
  </div>
  <ng-container *ngIf="employeeModel.venueEmployeeTypeId && (employeeModel.venueEmployeeTypeId === employeeRoleEnum.Waiter || employeeModel.venueEmployeeTypeId === employeeRoleEnum.Manager)">
    <div class="d-flex flex-row justify-content-between pb-2 mt-2">
      <div class="w-50">
        <button (click)="generatePin()" class=" p-0 btn_magenta_large w-100 mt-2" [class.btn_cyan_large]="employeeHasPIN(employeeModel.pin)">
          {{employeeHasPIN(employeeModel.pin) ? employeeModel.pin : 'EMPLOYEES.GENERATE_PIN' | translate}}
        </button>
      </div>
      <div class="w-50">
        <p class="primary_medium_text_14 mt-1">
          {{'EMPLOYEES.GENERATE_PIN_MESSAGE' | translate}}
        </p>
      </div>
    </div>
  </ng-container>
  <div class="d-flex flex-row justify-content-between pb-2">
    <button *ngIf="!enableEdit" class="btn_login w-100" (click)="addEmployee(employeeModel)"
            [disabled]="email.errors?.pattern || !employeeModel.venueEmployeeTypeId || (employeeModel.venueEmployeeTypeId === employeeRoleEnum.Waiter && !employeeModel.pin)">{{ 'SAVE' | translate}}</button>
    <button *ngIf="enableEdit" class="btn_login w-100" (click)="updateEmployee(employeeModel)"
            [disabled]="email.errors?.pattern || !employeeModel.venueEmployeeTypeId || (employeeModel.venueEmployeeTypeId === employeeRoleEnum.Waiter && (employeeModel.pin === '0000' || employeeModel.pin.trim() === ''))">{{ 'SAVE' | translate}}</button>
  </div>
</div>
<p-toast position="top-center" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"></p-toast>
